// Per-visitor countdown, persisted in localStorage so it never fake-resets on reload.
// Length is merchant-configurable via the section's "Countdown length (hours)" setting.
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  document.querySelectorAll('[data-wingman-countdown]').forEach(function (el) {
    var hours = parseFloat(el.dataset.hours) || 48;
    var windowMs = hours * 60 * 60 * 1000;
    var storageKey = 'wingmanOfferDeadline:' + (el.id || 'default');

    var deadline = parseInt(localStorage.getItem(storageKey), 10);
    if (!deadline || isNaN(deadline)) {
      deadline = Date.now() + windowMs;
      localStorage.setItem(storageKey, String(deadline));
    }

    var timer;
    function tick() {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        el.textContent = '00:00:00';
        clearInterval(timer);
        return;
      }
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    tick();
    timer = setInterval(tick, 1000);
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  if (window.lucide) {
    // Every icon here is decorative (paired with visible text) — hide from assistive tech.
    lucide.createIcons({ attrs: { 'aria-hidden': 'true', focusable: 'false' } });
  }

  document.querySelectorAll('.wingman-landing').forEach(function (root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Hero entrance: cascades in once on load, no scroll trigger needed (it's above the fold)
    var heroItems = root.querySelectorAll(
      '.hero .badge, .hero-title, .hero-subtitle, .hero-cta, .stats-bar, .hero-visual'
    );
    heroItems.forEach(function (el, i) {
      el.classList.add('reveal');
      window.setTimeout(function () {
        el.classList.add('is-visible');
      }, 120 + i * 110);
    });

    // Scroll-triggered reveals, staggered within each group so grids/lists cascade in
    var groups = [
      '.feature-grid > *',
      '.comparison-container > *',
      '.testimonial-grid > *',
      '.faq-list > *',
      '.pricing-card',
      '.section-heading',
    ];

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -40px 0px', threshold: 0.1 }
    );

    groups.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (el, i) {
        el.classList.add('reveal');
        el.style.transitionDelay = i * 90 + 'ms';
        observer.observe(el);
      });
    });
  });
});
